<template>
  <div class="pad__row pad__row--first">
    <div class="pad__info">
      <div class="pad__head">
        <pad-link :link="link" css_class="d-block h-100">
          <h2 v-b-popover.hover.top="hotel.name" class="pad__head-name">{{ hotel.name }}</h2>
        </pad-link>
        <div class="pad__head-star" v-if="hotel.ratings.property">
          <b-form-rating
            no-border inline readonly
            size="sm"
            variant="secondary"
            :value="hotel.ratings.property.rating"
          />
        </div>
        <p class="pad__head-category" v-if="get_categories(hotel.salabam_category_id)">
          {{ get_categories(hotel.salabam_category_id) }}
        </p>
      </div>
      <div v-if="hotel.location" class="pad__address">
        <span
          class="pad__address-map"
          :class="{ 'pad__address-map--unavailable': !hotel.room }"
          @click="hotel.room && $emit('toggle-map')"
        >
          <vb-icon :name="'pin'" :color="sass('primary')" :size="12" class="mr-1" />
          {{hotel.location.city}}
        </span>
        <span v-if="hotel.location.proximity_distance" class="pad__address-proximity" v-b-popover.hover.right="'La distanza è in linea d’aria. Il percorso reale potrebbe essere diverso.'">
          <vb-icon :name="'flag'" :color="sass('secondary')" :size="12" class="mr-1" />
          <span v-if="location.name">
            {{ round(hotel.location.proximity_distance, 1) }} km dal centro di {{ last_search_location.name }}
          </span>
          <span v-else>distanza {{ round(hotel.location.proximity_distance, 1) }} km </span>
          <vb-icon class="ml-1" :name="'info'" :color="sass('secondary')" :size="14" />
        </span>
      </div>
    </div>
    <score
      class="pad__score"
      :direction="'row'"
      :rating="hotel.ratings.salabam_score"
    />
  </div>
</template>

<script>
import { round } from 'mathjs'
import { get_categories } from '@liveeps/resources'
import { decode_parameters } from '@utilities'
import { mapState } from 'vuex'
import Score from "@liveeps/components/atoms/score.vue"
import PadLink from "@liveeps/components/blocks/pad-link.vue"

export default {
  name: "pad-heading",

  components: {
    'score': Score,
    'pad-link': PadLink,
  },

  props: {
    hotel: Object,
    link: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      last_search_location: ''
    }
  },

  computed: {
    ...mapState(
      'liveeps', [
        'location',
        'current_search',
      ]
    ),
  },

  created() {
    this.get_categories = get_categories
    this.round = round
  },

  mounted() {
    this.last_search_location = decode_parameters(this.current_search).suggestion
  },
}
</script>

<style lang="scss" scoped>

  .pad {

    &__row {
      display: flex;
      flex-direction: column;

      @include media-breakpoint-up(md){
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }

    &__info {
      // evita che un nome lungo allarghi la colonna e spinga via lo score
      min-width: 0;
    }

    &__head {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      @include media-breakpoint-up(lg) {
        flex-wrap: nowrap;
        position: relative;
      }

      // il titolo è dentro un custom-link: anche il wrapper deve poter
      // restringersi, altrimenti il troncamento non scatta
      > .custom-link {
        @include media-breakpoint-up(md) {
          min-width: 0;
        }
      }

      &-name {
        font-size: $font-size-lg;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: 0;
        margin-right: 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 250px;
        position: relative;
        padding-left: $grid-gutter-width / 2;

        // su schermi più grandi il titolo occupa tutto lo spazio che gli
        // lasciano stelle e categoria: tronca solo quando serve davvero
        @include media-breakpoint-up(md) {
          min-width: 0;
          max-width: 100%;
        }

        &:before {
          content: '';
          width: $grid-gutter-width / 5;
          background-color: var(--secondary);
          position: absolute;
          top: 3px;
          bottom: 3px;
          left: 0;
          border-radius: $border-radius;
        }
      }

      &-star {
        display: flex;
        margin-right: 5px;
        // non si restringono: lo spazio in eccesso lo prende il titolo
        flex-shrink: 0;
      }

      &-category {
        color: $gray-600;
        font-size: $font-size-sm;
        position: absolute;
        z-index: 1;
        top: 10px;
        left: 10px;
        background-color: $white;
        padding: 4px 5px;
        border-radius: $border-radius;
        margin-bottom: 0;

        @include media-breakpoint-up(lg){
          position: static;
          background-color: transparent;
          padding: 0;
          border-radius: 0;
          white-space: nowrap;
          flex-shrink: 0;

          &:before {
            content: "("
          }
          &:after {
            content: ")"
          }
        }
      }
    }

    &__address {
      font-size: $font-size-md;

      @include media-breakpoint-up(md){
        display: flex;
        align-items: center;
      }

      &-map, &-proximity {
        display: flex;
        align-items: center;
      }

      &-map {
        font-weight: $vb-font-weight-semibold;
        color: var(--info);
        cursor: pointer;

        &--unavailable {
          color: inherit;
          cursor: default;
          text-decoration: none;
        }
      }

      &-proximity {
        color: var(--secondary);

        @include media-breakpoint-up(md){
          margin-left: $grid-gutter-width/3;
        }
      }
    }

    &__score {
      justify-content: flex-end;

      @include media-breakpoint-up(lg) {
        position: static;
      }
    }
  }

</style>
